import { useState, useMemo, useEffect } from "@wordpress/element";
import React, { FC } from "react";
import apiFetch from "@wordpress/api-fetch";
import Filters from "./Filters";
import { FiltersProvider, FiltersValue } from "../../context/filters-context";
import ResetFilters from "./ResetFilters";
import { GetFilteredSpecsRes } from "../../types";

// Container, permettant de « provide » le contexte
// aux éléments enfants, et permet la gestion du
// fetch au changement des filtres.
const FiltersContainer: FC = () => {
  const [filters, setFilters] = useState<FiltersValue>({});
  const [hasFetched, setHasFetched] = useState(false);
  const date = useMemo(() => filters.date, [filters]);
  const categorie = useMemo(() => filters.categorie, [filters]);
  const lieu = useMemo(() => filters.lieu, [filters]);
  const type_spectacle = useMemo(() => filters.type_spectacle, [filters]);

  useEffect(() => {
    const params = new URLSearchParams();
    if (saison) {
      params.set("saison", saison);
    }
    if (date && date.length) {
      params.set("date", date);
    }
    if (categorie) {
      params.set("categorie", categorie);
    }
    if (
      type_spectacle &&
      (typeof selected_type === "undefined" || !selected_type)
    ) {
      params.set("type_spectacle", type_spectacle);
    }
    if (typeof selected_type !== "undefined" && selected_type) {
      params.set("type_spectacle", String(selected_type));
    }
    if (lieu) {
      params.set("lieu", lieu);
    }
    if (date || categorie || lieu || type_spectacle || hasFetched) {
      apiFetch({
        path: `/fleuriaye/v1/get_filtered_specs?${params.toString()}`,
      }).then((res) => {
        const response = res as GetFilteredSpecsRes;
        setHasFetched(true);
        if (response && response.response && response.response.length) {
          const temp = document.createElement("div");
          temp.innerHTML = response.response;
          const grid = document.querySelector(
            ".page-content .grid.grid-3, .page-content .no-specs_res"
          );
          grid?.replaceWith(...temp.childNodes);
        } else {
          const temp = document.createElement("div");
          temp.innerHTML =
            '<h2 class="no-specs_res">Aucun résultat trouvé avec ces filtres.</h2>';
          const grid = document.querySelector(".page-content .grid.grid-3");
          grid?.replaceWith(...temp.childNodes);
        }

        if (is_main_archive) {
          document
            .querySelector(".page-content")
            ?.scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }, [date, categorie, lieu, type_spectacle]);

  return (
    <FiltersProvider value={{ filters, setFilters }}>
      <div className="filters_container">
        <Filters />
        <ResetFilters />
      </div>
    </FiltersProvider>
  );
};

export default FiltersContainer;
